// API contracts shared between the client and server. Once the OpenAPI
// spec stabilises, these should be auto-generated from
// /openapi/v1.json by openapi-typescript in a CI step — until then they
// are hand-maintained.

// Mirrors DPAS.AuditTool.Domain.Audits.AuditStatus. The wire value is the
// enum's *name*, so these strings are the contract. Slice 18a: 'Active'
// became 'InProgress' and 'Archived' was retired — shelf state is a separate
// concern (see ADR-0001), not a status.
export type AuditStatus = 'Draft' | 'InProgress' | 'Completed' | 'Cancelled';

/** Display labels for {@link AuditStatus} — the wire values are PascalCase. */
export const AUDIT_STATUS_LABELS: Record<AuditStatus, string> = {
  Draft:      'Draft',
  InProgress: 'In progress',
  Completed:  'Completed',
  Cancelled:  'Cancelled',
};

/** Mirrors DPAS.AuditTool.Domain.Audits.ArchiveReason. */
export type ArchiveReason = 'Completed' | 'Cancelled' | 'Superseded' | 'Other';

export const ARCHIVE_REASON_LABELS: Record<ArchiveReason, string> = {
  Completed:  'Completed and sent',
  Cancelled:  'Engagement cancelled',
  Superseded: 'Superseded by a later audit',
  Other:      'Other',
};

// ------------------------------------------------------------------
//  Dashboard (Slice 18c) — cross-module, so these shapes are the
//  platform's WorkItemSummary rather than anything audit-specific.
// ------------------------------------------------------------------

export type AttentionReason = 'Idle' | 'Overdue' | 'StaleLock' | 'ReportRetracted';

export const ATTENTION_REASON_LABELS: Record<AttentionReason, string> = {
  Idle:            'No activity for 30 days',
  Overdue:         'Past its due date',
  StaleLock:       'Left open by someone',
  ReportRetracted: 'Report retracted, nothing republished',
};

/** Two counts, never a percentage — see ProgressCount server-side for why. */
export type Progress = { done: number; total: number };

export type DashboardItem = {
  id: string;
  product: string;
  title: string;
  organisationName: string | null;
  stage: string;
  stageOrder: number;
  formProgress: Progress | null;
  reportProgress: Progress | null;
  dueDate: string | null;
  lastActivityAtUtc: string;
  attention: AttentionReason[];
  detailPath: string;
};

export type DashboardStageCount = {
  product: string;
  stage: string;
  stageOrder: number;
  count: number;
};

export type Dashboard = {
  pipeline: DashboardStageCount[];
  items: DashboardItem[];
};

/** Which slice of the tenant's audits to list. Matches AuditListScope server-side. */
export type AuditListScope = 'open' | 'archived' | 'all';

export type AuditSummary = {
  id: string;
  title: string;
  status: AuditStatus;
  createdAtUtc: string;
  /**
   * Last substantive change — answer, comment, narrative section, evidence,
   * snapshot or metadata patch. Slice 18a made this true; before it, the
   * value mostly repeated createdAtUtc.
   */
  updatedAtUtc: string;
  dueDate: string | null;
  /** Null while the audit is open. */
  archivedAtUtc: string | null;
  archiveReason: ArchiveReason | null;
  archiveNote: string | null;
};

/** One page of audits plus the total the page was drawn from. */
export type PagedAudits = {
  items: AuditSummary[];
  totalCount: number;
};

export type LockState = {
  auditId: string;
  lockedByUserId: string;
  acquiredAtUtc: string;
  expiresAtUtc: string;
  lastHeartbeatAtUtc: string;
};

export type ApiInfo = {
  name: string;
  version: string;
  environment: string;
  machineName: string;
  timestampUtc: string;
  modules: string[];
};
